import Logo from '../../components/Logo/Logo';
import styles from './AuthLayout.module.css';

function AuthLayout({ title = 'Log in', children }) {
  return (
    <div className={`${styles.page} d-md-flex align-items-md-start justify-content-md-center`}>
      <div className={styles.logoWrapper}>
        <Logo height={36} />
      </div>
      <div className={`${styles.card} w-100`}>
        <h1 className={`${styles.title} mb-4`}>{title}</h1>
        {children}
      </div>
    </div>
  );
}

export default AuthLayout;
